export enum MessageType {
  Support = 'SUPPORT',
  Announcement = 'ANNOUNCEMENT',
  Poll = 'POLL',
  Notification = 'NOTIFICATION',
  Order = 'ORDER'
}
